<template>
  <v-container
    fluid
    row
    fill-height
    v-if="myself !== null && tplchoosed != null"
  >
    <v-layout justify-center fill-height>
      <v-flex xs12 fill-height>
        <component
          ref="mysun"
          v-bind:is="tplchoosed"
          :myself="myself"
        ></component>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
try {
  var crudcampo = require("@/admin/listagem/crudcampo").default;
} catch (err) {
  var crudcampo = require("@/framework/admin/listagem/crudcampo").default;
}

const components = { crudcampo };

for (let cnome of global.reqClass.tpl_client) {
  components["tpl" + cnome] = global.reqClass.requirecmpmix(
    "@/admin/tpl/" + cnome
  );
}

for (let cnome of global.reqClass.tpluser_client) {
  components["tpluser" + cnome] = global.reqClass.requirecmpmix(
    "@/lib/tpl/" + cnome
  );
}

export default {
  name: "crud-tag",
  props: ["embedprops", "returnfn", "backfn", "getcontrol", "json"],

  beforeRouteLeave(to, from, next) {
    if (global.fn.routeLeaveControl) {
      return global.fn.routeLeaveControl(to, from, next, this.myself);
    }
    next();
  },

  data() {
    return {
      full_search_timer: null,
      full_search_loading: false,
      displayDialogData: null,
      displayDialog: false,

      embed: this.embedprops, //embeb props (para uso dentro de outra pagina)

      paginationActive: {}, //obj gerencia a paginacao
      selected: [], //itens selecionados na listagem checkboxes

      lista: null, //json do modulo
      listaFixaCampos: null, //json do modulo
      action: null, //acao atual (new, edit, view, list)
      sid: null, //uniq code da pagina para separacao de escopo
      module: null, //nome do modulo

      classCrud: null, //classe crud carregada
      myself: null, //referencia propria para passar ao tabelado
      tplchoosed: null, //template carregado. tabelado por ex.

      loading: true, //loading externo. esconde tudo e mostra loading
      loadingIntra: true, //loading interno, Dentro da listagem

      errorMsg: null, //mensagem de erro bloquente (erro de operações crud - Exemplo. Erro ao salvar)
      errorBox: {
        //Janela alert de erro
        display: false,
        text: ""
      },
      alertBox: {
        //Janela alert de mensagem normal(verde)
        display: false,
        text: ""
      },

      pageloaded: null, //para controle de modulo que carrega uma page

      localsession: this.iniciarSession(), //carrega sessao da memoria do navegador (limite 1 dia)
      configcruds: {},

      gerenciarDialog: false, //janela de gerenciar campos

      //LISTA
      resultset: null, //dados do data-tables
      headers: [], //colunas do data-tables

      totalItems: 0, //total de registros no banco de dados
      metadata: {}, //metadados. (colunas nao exibir por exemplo)
      metadataextra: {}, //metadados extras para uso em componentes..

      // FORMULARIO
      form: {}, //dados do formulario (edit, new, view)
      abas: null, //estrutura de abas montado p/ tabelado
      abasmodel: null, //aba selecionada.
      valid: true, //resultado do processamento das validacoes (true=tudo permitido)

      configprops: {
        //propriedade default do modulo (o que mostra ou nao)
        filtro: true,
        gc: true,
        titulo: true,
        rodape: true,
        paginacao: true,
        select: true,
        acoes: true,
        colsort: true,
        exportscreen: "pecji",
        exportserver: false
      },

      optionsDrag: null,

      fab: false,
      fab2: false
    };
  },

  methods: {
    iniciarSession() {
      let ls = this.$store.state.localsession;
      for (let lsi in ls) {
        if (new Date().getTime() - lsi * 1 > 60 * 60 * 24 * 1000)
          delete ls[lsi];
      }
      return ls;
    },

    async _beforeMount(forced = false) {
      this.myself = this;

      if (this.getcontrol) {
        this.getcontrol(this.myself);
      }
      this.loading = true;

      try {
        let routemap;
        if (this.embed != null) {
          routemap = this.embed;
        } else {
          routemap = this.$store.state.route;
        }

        this.module = routemap.params.module;
        this.action = routemap.params.action;
        this.actionid = routemap.params.id;

        if (this.action == "reload") {
          setTimeout(() => {
            if (this.embed == null) {
              this.$router.replace({
                path: `/admin/app/${this.module}`
              });
            } else {
              routemap.params = {
                module: this.module
              };
            }
          }, 100);
        }
        //Geracao do SID
        this.sid = routemap.params.sid;

        if (this.configcruds[this.module] == null) {
          this.configcruds[this.module] = {};
          this.configcruds[this.module].filtrohide = [];
          this.configcruds[this.module].filtrosShow = [];
          this.configcruds[this.module].filtrosel = null;
          this.configcruds[this.module].displayCols = {};
          this.configcruds[this.module].orderCols = [];
          this.configcruds[this.module].idiomas = null;
        }

        if (
          this.sid == null ||
          this.sid == "open" ||
          this.localsession[this.sid] == null
        ) {
          this.sid = new Date().getTime();

          routemap.params.sid = this.sid;

          this.localsession[this.sid] = {};

          if (routemap.query && routemap.query.joined) {
            this.localsession[this.sid].joined = routemap.query.joined;
            this.localsession[this.sid].joinedid = routemap.query.joinedid;
            this.localsession[this.sid].joinedfrom = routemap.query.joinedfrom;
            this.localsession[this.sid].joinedsid = routemap.query.joinedsid;
            this.localsession[this.sid].joinedcolunaorig =
              routemap.query.joinedcolunaorig;
            this.localsession[this.sid].joinedcolunadest =
              routemap.query.joinedcolunadest;
          }

          if (routemap.query && routemap.query.data) {
            let dataobj = routemap.query.data;
            let arr1 = dataobj.split(";").map(v => {
              let arr2 = v.split(":");
              return { k: arr2[0], v: arr2[1] };
            });
            let datamap = {};
            for (let x of arr1) {
              datamap[x.k] = x.v;
            }
            this.localsession[this.sid].data = datamap;
          }

          this.localsession[this.sid].filtro = {};

          if (routemap.query && routemap.query.filtro) {
            this.localsession[this.sid].filtro = routemap.query.filtro;
          }

          this.localsession[this.sid].requestSave = false;
          this.localsession[this.sid].primeiroSid = true;

          this.localsession[this.sid].full_search = null;
          this.localsession[this.sid].group_list = [];

          if (routemap.query && routemap.query.full_search) {
            this.localsession[this.sid].full_search =
              routemap.query.full_search;
          }

          //console.log("localSession", this.localsession);

          if (this.action == null && this.actionid == null) {
            if (this.embed == null) {
              this.$router.replace({
                path: `/admin/app/${this.module}/${this.sid}/list`
              });
            } else {
              routemap.params = {
                module: this.module,
                sid: this.sid,
                action: "list"
              };
            }
          } else if (this.actionid == null) {
            if (this.embed == null) {
              this.$router.replace({
                path: `/admin/app/${this.module}/${this.sid}/${this.action}`
              });
            } else {
              routemap.params = {
                module: this.module,
                sid: this.sid,
                action: this.action
              };
            }
          } else if (this.actionid != null) {
            if (this.embed == null) {
              this.$router.replace({
                path: `/admin/app/${this.module}/${this.sid}/${this.action}/${this.actionid}`
              });
            } else {
              routemap.params = {
                module: this.module,
                sid: this.sid,
                action: this.action,
                id: this.actionid
              };
            }
          }
        }

        this.lista = await require(`@/lib/dbdef/${this.module}.json`);
        this.listaFixaCampos = JSON.parse(JSON.stringify(this.lista.campos));

        let p1 = window.document.title.split(" - ");
        window.document.title =
          p1[0] + " - " + this.T(this.lista.modulo.mod_titulo);

        //definir template:

        if (
          components[
            "tpluser" + this.lista.modulo.mod_tabela + "-" + this.action
          ]
        )
          this.tplchoosed =
            "tpluser" + this.lista.modulo.mod_tabela + "-" + this.action;
        else if (components["tpluser" + this.lista.modulo.mod_tabela])
          this.tplchoosed = "tpluser" + this.lista.modulo.mod_tabela;
        else if (components["tpluser" + this.lista.modulo.tpl])
          this.tplchoosed = "tpluser" + this.lista.modulo.tpl;
        else if (components["tpl" + this.lista.modulo.tpl])
          this.tplchoosed = "tpl" + this.lista.modulo.tpl;

        if (this.lista.campos.filter(c => c.cmp_idioma === true).length > 0) {
          this.configcruds[this.module].idiomas =
            global.config.metadmin.multilang.langs;
        }

        //Carga da classe listagem herdada
        let ListagemClass = null;
        try {
          ListagemClass = (
            await global.reqClass.requirecmpmix(
              `@/classes/metadmin/listagem/${this.module}`
            )()
          ).default;
          if (ListagemClass == null) throw new Error("not found");
        } catch (e) {
          try {
            try {
              ListagemClass = require("@/classes/metadmin/metadmin_listagem")
                .default;
            } catch (err) {
              try {
                ListagemClass = require("@/framework/classes/metadmin/metadmin_listagem")
                  .default;
              } catch (err) {}
            }

            if (ListagemClass == null) throw new Error("not found");
          } catch (e) {
            try {
              ListagemClass = require("@/classes/metadmin/basecrud").default;
            } catch (err) {
              try {
                ListagemClass = require("@/framework/classes/metadmin/basecrud")
                  .default;
              } catch (err) {}
            }

            if (ListagemClass == null) throw new Error("not found");
          }
        }
        this.classCrud = new ListagemClass(
          this.module,
          JSON.parse(JSON.stringify(this.lista)),
          routemap.params,
          this
        );

        this.classCrud.listaJsonTransform();

        await this.startLoadCrud(forced);
        console.log("READY");

        this._pageReady();
      } catch (err) {
        console.log(err);
      }
    },

    async startLoadCrud(forced = null) {
      return await this.classCrud.startLoadCrud.bind(this)(forced);
    },

    _fillDataTable(colchanged = null) {
      return this.classCrud._fillDataTable.bind(this)(colchanged);
    },

    displayErrorBox(msg) {
      return this.classCrud.displayErrorBox.bind(this)(msg);
    },
    displayAlertBox(msg) {
      return this.classCrud.displayAlertBox.bind(this)(msg);
    },

    resetScope() {
      return this.classCrud.resetScope.bind(this)();
    },

    setConfigProps() {
      return this.classCrud.setConfigProps.bind(this)();
    },

    _trataTpl(tplparam, campos, action) {
      return this.classCrud._trataTpl.bind(this)(tplparam, campos, action);
    },
    editItem(item, lang = null) {
      return this.classCrud.editItem.bind(this)(item, lang);
    },
    flowItem(item) {
      return this.classCrud.flowItem.bind(this)(item);
    },

    viewItem(item) {
      return this.classCrud.viewItem.bind(this)(item);
    },
    cloneItem(item) {
      return this.classCrud.cloneItem.bind(this)(item);
    },
    async deleteItem(item) {
      return await this.classCrud.deleteItem.bind(this)(item);
    },
    async forceReload() {
      return await this.classCrud.forceReload.bind(this)();
    },

    async loadAll() {
      return await this.classCrud.loadAll.bind(this)();
    },
    async carregaTudoJson() {
      return await this.classCrud.carregaTudoJson.bind(this)();
    },

    async gerarExcel($refs, all = null) {
      return await this.classCrud.gerarExcel.bind(this)($refs, all);
    },

    async gerarCSV($refs, all = null) {
      return await this.classCrud.gerarCSV.bind(this)($refs, all);
    },

    async gerarJSON($refs, all = null) {
      return await this.classCrud.gerarJSON.bind(this)($refs, all);
    },
    async gerarPDF($refs, all = null) {
      return await this.classCrud.gerarPDF.bind(this)($refs, all);
    },
    gerarPrint() {
      return this.classCrud.gerarPrint.bind(this)();
    },

    captureAndDisplayError(e) {
      return this.classCrud.captureAndDisplayError.bind(this)(e);
    },

    captureAndDisplayErrorToast(e) {
      return this.classCrud.captureAndDisplayErrorToast.bind(this)(e);
    },

    async loadZero(id, clone = null, formprevio = null) {
      //form add
      return await this.classCrud.loadZero.bind(this)(id, clone, formprevio);
    },

    async loadOne(id, clone = null) {
      //edit
      return await this.classCrud.loadOne.bind(this)(id, clone);
    },

    async loadOneView(id) {
      //view
      return await this.classCrud.loadOneView.bind(this)(id);
    },

    add() {
      return this.classCrud.add.bind(this)();
    },

    async save_add() {
      return await this.classCrud.save_add.bind(this)();
    },

    async save_edit(flowact = null) {
      return await this.classCrud.save_edit.bind(this)(flowact);
    },

    async full_search_press() {
      return await this.classCrud.full_search_press.bind(this)();
    },
    full_search_extract(param) {
      return this.classCrud.full_search_extract.bind(this)(param);
    },

    async executeFunction(functionName, args) {
      return await this.classCrud.executeFunction.bind(this)(
        functionName,
        args
      );
    },

    executeFunctionSync(functionName, args) {
      return this.classCrud.executeFunctionSync.bind(this)(functionName, args);
    },

    canExecuteFunction(functionName, args) {
      return this.classCrud.canExecuteFunction.bind(this)(functionName, args);
    },

    dataParam(key) {
      return this.classCrud.dataParam.bind(this)(key);
    },

    avaliaPermissao(acao, obj) {
      return this.classCrud.avaliaPermissao.bind(this)(acao, obj);
    },

    _toggleAll() {
      return this.classCrud._toggleAll.bind(this)();
    },
    _changeSort(header) {
      return this.classCrud._changeSort.bind(this)(header);
    },

    _formSubmit(form, flowact = null) {
      return this.classCrud._formSubmit.bind(this)(form, flowact);
    },
    _formClear(form) {
      return this.classCrud._formClear.bind(this)(form);
    },

    _goBack() {
      return this.classCrud._goBack.bind(this)();
    },

    evaluatedCustom(custom, id, row) {
      return this.classCrud.evaluatedCustom.bind(this)(custom, id, row);
    },
    async toggleGroup(header) {
      return this.classCrud.toggleGroup.bind(this)(header);
    },
    hasGroup(header) {
      return this.classCrud.hasGroup.bind(this)(header);
    },

    returnFromJoin(joinpack) {
      return this.classCrud.returnFromJoin.bind(this)(joinpack);
    },

    navigateToModule(name, query = null) {
      return this.classCrud.navigateToModule.bind(this)(name, query);
    },

    callAction(actionName, id, extra = {}, callback = null, callbacke = null) {
      return this.classCrud.callAction.bind(this)(
        actionName,
        id,
        extra,
        callback,
        callbacke
      );
    },

    callFlowAction(actionName, id) {
      return this.classCrud.callFlowAction.bind(this)(actionName, id);
    },

    filtrar() {
      return this.classCrud.filtrar.bind(this)();
    },

    pertenceAListaK(coluna, lista = []) {
      return this.classCrud.pertenceAListaK.bind(this)(coluna, lista);
    },

    hideFiltro(campo, automatic) {
      return this.classCrud.hideFiltro.bind(this)(campo, automatic);
    },

    addFiltro() {
      return this.classCrud.addFiltro.bind(this)();
    },

    filtrosShowUpdate() {
      return this.classCrud.filtrosShowUpdate.bind(this)();
    },

    colsShowUpdate() {
      return this.classCrud.colsShowUpdate.bind(this)();
    },

    gerenciarCampos() {
      return this.classCrud.gerenciarCampos.bind(this)();
    },

    syncStoreSession() {
      return this.classCrud.syncStoreSession.bind(this)();
    },
    evalrules(campo) {
      return this.classCrud.evalrules.bind(this)(campo);
    },
    alterouPaginacao(old, newv) {
      return this.classCrud.alterouPaginacao.bind(this)(old, newv);
    },
    async validationOnSave() {
      return await this.classCrud.validationOnSave.bind(this)();
    },

    addOrdenacao() {
      return this.classCrud.addOrdenacao.bind(this)();
    },
    addCampoRef(coluna, obj) {
      return this.classCrud.addCampoRef.bind(this)(coluna, obj);
    },

    async saveFiltrosAndCols() {
      return await this.classCrud.saveFiltrosAndCols.bind(this)();
    },
    alterouOrdemCols(event) {
      return this.classCrud.alterouOrdemCols.bind(this)(event);
    },
    forceReloadCrud() {
      return this.classCrud.forceReloadCrud.bind(this)();
    },
    loadNextPack($state) {
      return this.classCrud.loadNextPack.bind(this)($state);
    },

    /**************************************TOMOVE */
    showStack() {
      this.errorMsg +=
        "<p class='text-xs-left'>" + window.lastErrorStack + "</p>";
    },

    _dataChanged() {
      return this.classCrud._dataChanged.bind(this)();
    },
    _pageReady() {
      return this.classCrud._pageReady.bind(this)();
    }
  },

  destroyed() {
    let p1 = window.document.title.split(" - ");
    window.document.title = p1[0];
  },
  async beforeMount() {
    return await this._beforeMount();
  },

  watch: {
    "$route.params": function(id) {
      this.oldHash = null;
      this._beforeMount();
    },
    "embed.params": {
      handler(old, newv) {
        this.oldHash = null;
        this._beforeMount();
      },
      deep: true
    },

    form: {
      handler(old, newv) {
        this._dataChanged();
      },
      deep: true
    },

    paginationActive: {
      handler(old, newv) {
        this.alterouPaginacao(old, newv);
      },
      deep: true
    },
    localsession: {
      handler(old, newv) {
        this.syncStoreSession();
      },
      deep: true
    },
    async gerenciarDialog(val) {
      if (val == false) {
        await this.saveFiltrosAndCols();
        this.forceReloadCrud();
      }
    }
  },
  components
};
</script>

<style scoped>
.crudtable {
  width: 100%;
}
</style>
